import global from '~/mixins/global';

const cluster_styles = {
	// Tool for changing PNG color tone easily -> https://onlinepngtools.com/change-png-color-tone
	// Tool for changing SVG colors (really good) -> https://deeditor.com/
	// Tool for editing SVG (shapes, transparent bg etc) -> https://pixelied.com/features/svg-editor

	// Will be modified on MapWrapper if on PartnerLocation routes
	main: [
		{
			textColor: 'white',
			textSize: '12',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/cluster-orange-1.svg`,
			height: 32,
			width: 32
		},
		{
			textColor: 'white',
			textSize: '14',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/cluster-orange-2.svg`,
			height: 46,
			width: 46
		},
		{
			textColor: 'white',
			textSize: '12',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/obi/cluster-orange-1-obi-new.svg`,
			height: 32,
			width: 32
		},
		{
			textColor: 'white',
			textSize: '14',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/obi/cluster-orange-2-obi-new.svg`,
			height: 46,
			width: 46
		},
		{
			textColor: 'white',
			textSize: '12',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/hornbach/cluster-orange-1-hornbach.svg`,
			height: 32,
			width: 32
		},
		{
			textColor: 'white',
			textSize: '14',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/hornbach/cluster-orange-2-hornbach.svg`,
			height: 46,
			width: 46
		}
	],
	foreign: [
		{
			textColor: 'white',
			textSize: '12',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/cluster-pink-1.svg`,
			height: 32,
			width: 32
		},
		{
			textColor: 'white',
			textSize: '14',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/cluster-pink-2.svg`,
			height: 46,
			width: 46
		},
		{
			textColor: 'white',
			textSize: '12',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/obi/cluster-pink-1-obi-new.svg`,
			height: 32,
			width: 32
		},
		{
			textColor: 'white',
			textSize: '14',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/obi/cluster-pink-2-obi-new.svg`,
			height: 46,
			width: 46
		},
		{
			textColor: 'white',
			textSize: '12',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/hornbach/cluster-pink-1-hornbach.svg`,
			height: 32,
			width: 32
		},
		{
			textColor: 'white',
			textSize: '14',
			anchorText: [0, 0],
			url: `${global.data().staticAssetsPath}/icons/gmap/hornbach/cluster-pink-2-hornbach.svg`,
			height: 46,
			width: 46
		}
	]
};

export { cluster_styles };
